
import { JobItemType, Status } from '@/common/enumerations';
import DatePicker from '@/components/commonui/DatePicker.vue';
import { EventBus } from '@/event-bus';
import toISODateFormatter from '@/filters/toISOdate.formatter';
import {
  Client,
  EmployeeModel,
  IJobItemModel,
  IJobItemScheduleModel,
  JobItemModel,
  Status as JobItemModelStatus,
  JobItemScheduleModel,
  JobItemUpdateScheduleModel
} from '@/services/api.service';
import { JobItemScheduleUpdatedMessage, JobItemStatusChangedMessage } from '@/services/eventbus.models';
import * as DateUtils from '@/utilities/date.utils';
import * as StringUtils from '@/utilities/string.utils';
import { Guid } from 'guid-typescript';
import { Component, Vue } from 'vue-property-decorator';
import vSelect from 'vue-select';

@Component({
    components: {
        vSelect,
        DatePicker
    },
    props: {
        jobItem: {
            type: Object as () => IJobItemModel,
            required: true,
        },
        jobItemSchedule: {
            type: Object as () => IJobItemScheduleModel,
            required: false,
        },
        jobGid: String,
        isInDialogMode: Boolean,
    },
    filters: {
      toISODate: toISODateFormatter
  }
})
export default class ScheduleJobItem extends Vue {

  private data: IJobItemScheduleModel = new JobItemScheduleModel();
  private itemName: string = '';
  private isNewSchedule: boolean = false;

  // public assignedEmployeeGid: string = '';
  public assignableEmployees: EmployeeModel[] = [];

  private mounted() {
    // either we get a schedule passed in, or we new one up
    if (this.$props.jobItemSchedule !== null) {
      Object.assign(this.data, this.$props.jobItemSchedule);

      // set the scheduled date if it is null



    } else {
      this.data = new JobItemScheduleModel();
      // Default the date to tomorrow, or next available weekday
      this.data.scheduledDate = this.getNextWorkingDay();
      this.isNewSchedule = true;
    }
    this.updateAssignableEmployees(this.$props.jobItem.jobItemType);
    this.itemName = this.$props.jobItem.name;
  }

  private updateJobItemSchedule() {
    // Set the current scheduling for the item
    // @ts-ignore
    this.$Progress.start();

    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    const updateModel: JobItemUpdateScheduleModel = new JobItemUpdateScheduleModel();
    updateModel.jobItemGid = this.$props.jobItem.gid;
    if (this.isNewSchedule) {
      updateModel.jobItemScheduleGid = Guid.create().toString();
    } else {
      updateModel.jobItemScheduleGid = this.data.gid || Guid.create().toString();
    }

    updateModel.scheduledDateISO = DateUtils.toIsoDate(this.data.scheduledDate!);
    updateModel.scheduledTimeRange = this.data.scheduledTimeRange;
    updateModel.estimatedDurationInMinutes = this.data.estimatedDurationInMinutes;
    updateModel.estimatedTravelTimeInMinutes = this.data.estimatedTravelTimeInMinutes;
    updateModel.notes = this.data.notes;
    updateModel.assignedToEmployeeGid = this.data.assignedToEmployeeGid || undefined;


    clientService.scheduleJobItem(this.$props.jobGid, this.$props.jobItem.gid, updateModel).then((data) => {


      // update the current item with the new values
      // @ts-ignore
      this.$Progress.finish();
      // @ts-ignore
      this.$awn.success('Job successfully scheduled.');

      // clone the job item and update the state
      const ji: IJobItemModel = new JobItemModel(this.$props.jobItem);
      const oldStatus: JobItemModelStatus = ji.status!;
      const newStatus: JobItemModelStatus = Status.Scheduled as any as JobItemModelStatus;
      // push the event up to parent, and out on the event bus
      this.$emit('job-item-scheduled', data);
      EventBus.$emit('job-item-scheduled', new JobItemScheduleUpdatedMessage(this.$props.jobGid, this.$props.jobItem.gid, data));
      if (ji.status !== Status.Scheduled as any as JobItemModelStatus) {
        ji.status = newStatus;
        EventBus.$emit('job-item-status-changed', new JobItemStatusChangedMessage(this.$props.jobGid, oldStatus as any as Status, newStatus as any as Status, ji));
      }


      this.closeModal();
    }).catch((reason) => {
      // @ts-ignore
      this.$Progress.fail();
      // @ts-ignore
      this.$awn.alert('Failed to schedule the job item.\r\n' + reason.message);
    });

  }

  private cancelEdit() {
    console.log('Cancelling edit...');
    // this.$emit('close');
    this.closeModal();
  }

  private closeModal() {
    if (this.$props.isInDialogMode) {
        this.$modal.hide('modal-jobitem-schedule');
    }
  }

  private updateAssignableEmployees(jobItemType: JobItemType) {

    const currentEmployeeGid = this.data.assignedToEmployeeGid;
    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    const vm = this;
    this.assignableEmployees = [];
    const employees = clientService.getAssignableEmployees(jobItemType as any).then((data) => {


      const sortedData = data.sort((n1, n2) => StringUtils.stringCompare(n1.firstName || '', n2.firstName || ''));
      const assignableEmployeesPlaceholder = new EmployeeModel();
      assignableEmployeesPlaceholder.init({firstName : '(Select Employee...)', lastName: '', gid: '' });
      sortedData.unshift(assignableEmployeesPlaceholder);

      vm.assignableEmployees = sortedData;
      if (vm.assignableEmployees.filter((e) => e.gid === currentEmployeeGid).length !== 0) {
        vm.data.assignedToEmployeeGid = currentEmployeeGid;
      } else {
        vm.data.assignedToEmployeeGid = assignableEmployeesPlaceholder.gid!;
      }
    });
  }

  private getNextWorkingDay() {
    // Gets the next weekday from the current
    // date. Generally that is tomorrow, but
    // if today is Friday, then the next day
    // is the following Monday
    const d = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(d.getDate() + 1);
    // see if it is the weekend
    // 6 = Saturday, 0 = Sunday
    if (tomorrow.getDay() === 6 ) {
      tomorrow.setDate(tomorrow.getDate() + 2);
    }
    if (tomorrow.getDay() === 0 ) {
      tomorrow.setDate(tomorrow.getDate() + 1);
    }
    return tomorrow;
  }
}
